import { useState } from 'react';
import { Mail, Loader2 } from 'lucide-react';
import Button from '../ui/Button.jsx';
import { adminApi } from '../../lib/api.js';
import { useToast } from '../../hooks/useToast.jsx';

// "Send reminders now" trigger used on the Contracts and Documents
// pages. Calls the manual HTTP endpoint with a `kinds` filter and
// surfaces the count of items emailed (and any per-pipeline skip
// reasons — most commonly "no recipients configured").
export default function SendReminderButton({ kinds, label = 'Send reminders now' }) {
  const toast = useToast();
  const [busy, setBusy] = useState(false);

  async function handleClick() {
    if (!confirm('Send expiry reminder emails now to the recipients configured in Settings?')) return;
    setBusy(true);
    try {
      const res = await adminApi.sendExpiryReminders(kinds);
      const result = res.result || {};
      const messages = [];
      for (const k of kinds) {
        const r = result[k];
        if (!r) continue;
        if (r.skipped) messages.push(`${k}: ${r.skipped}`);
        else messages.push(`${k}: emailed ${r.recipients?.length || 0} recipient(s) about ${r.items?.length || 0} item(s)`);
      }
      if (messages.length === 0) toast.success('Reminders triggered');
      else toast.success(messages.join(' · '));
    } catch (err) {
      toast.error(`Reminder send failed: ${err.message}`);
    } finally {
      setBusy(false);
    }
  }

  return (
    <Button variant="secondary" onClick={handleClick} disabled={busy}>
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Mail className="h-4 w-4" />}
      {label}
    </Button>
  );
}
